import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { api } from "@/lib/api";
import { BlogCard } from "@/components/BlogTeaser";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { ArrowRight, Loader2 } from "lucide-react";

const BlogList = () => {
  const { t, locale } = useLanguage();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api
      .get("/blog/posts")
      .then(({ data }) => setPosts(data))
      .catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="blog-list-page" className="min-h-screen bg-[#fdfbf7] text-neutral-900">
      <Navigation />

      <main className="pt-32 lg:pt-40">
        <section className="container-px mx-auto max-w-7xl pb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">
            {t("blog.eyebrow")}
          </p>
          <h1 className="font-display mt-4 text-5xl lg:text-7xl font-light tracking-tighter text-neutral-950 text-balance max-w-3xl">
            {t("blog.title")}
          </h1>
          <p className="mt-5 text-lg text-neutral-700 max-w-2xl leading-relaxed">
            {t("blog.subtitle")}
          </p>
        </section>

        <section className="container-px mx-auto max-w-7xl pb-24 lg:pb-32">
          {posts === null ? (
            <div className="py-24 grid place-items-center">
              <Loader2 className="w-5 h-5 animate-spin text-neutral-400" />
            </div>
          ) : posts.length === 0 ? (
            <div className="py-24 text-center text-neutral-500" data-testid="blog-list-empty">
              {t("blog.empty")}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {posts.map((p) => (
                <BlogCard key={p.slug} post={p} t={t} locale={locale} />
              ))}
            </div>
          )}
        </section>

        {/* Bottom CTA */}
        <section className="bg-neutral-950 text-white">
          <div className="container-px mx-auto max-w-7xl py-20 lg:py-24 grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-display text-4xl lg:text-5xl font-light tracking-tighter text-balance">
                {t("blog.cta.title")}
              </h2>
              <p className="mt-4 text-neutral-300 max-w-lg">{t("blog.cta.subtitle")}</p>
            </div>
            <div className="flex lg:justify-end">
              <Link
                to="/#contact"
                className="inline-flex items-center gap-2 rounded-full bg-white text-neutral-950 px-6 py-4 text-sm font-medium hover:bg-sky-50 transition-colors"
              >
                {t("nav.cta")}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default BlogList;
